import React from "react";

/**
 * Official asia AI alliance logo.
 * layout: "horizontal" (navbar) | "vertical" (hero / stacked)
 * Variants: "light" (white on dark) or "dark" (inverted on light)
 * Sizes: sm | md | lg | xl
 */
const SIZE_HORIZONTAL = {
  sm: "h-5 sm:h-6 w-auto max-w-[160px] sm:max-w-[180px]",
  md: "h-7 md:h-8 w-auto max-w-[200px] md:max-w-[220px]",
  lg: "h-12 sm:h-14 md:h-16 w-auto",
  xl: "h-16 sm:h-20 md:h-24 w-auto",
};

const SIZE_VERTICAL = {
  sm: "h-11 sm:h-12 w-auto",
  md: "h-14 md:h-16 w-auto",
  lg: "h-20 sm:h-24 md:h-28 w-auto",
  xl: "h-28 sm:h-32 md:h-36 w-auto",
};

const LOGO_SRC = {
  horizontal: "/images/asia-ai-alliance-logo-horizontal.png",
  vertical: "/images/asia-ai-alliance-logo-vertical.png",
};

const Wordmark = ({
  size = "md",
  variant = "light",
  layout = "vertical",
  className = "",
}) => {
  const dimensions =
    layout === "horizontal"
      ? SIZE_HORIZONTAL[size] || SIZE_HORIZONTAL.md
      : SIZE_VERTICAL[size] || SIZE_VERTICAL.md;

  return (
    <img
      src={LOGO_SRC[layout] || LOGO_SRC.vertical}
      alt="asia AI alliance"
      className={`object-contain object-left ${dimensions} ${
        variant === "dark" ? "invert" : ""
      } ${className}`}
    />
  );
};

export default Wordmark;
